var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-icon-module"},[_c('a',{attrs:{"href":'https://help.source.co/' + _vm.getUrlHelp(),"target":"_blank"}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-help-circle-outline ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }